import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { AdvertiserInfoVO } from 'src/app/planner/interfaces/AdvertiserInfo';
import { GenderConst } from '../../planner-edit/constants/Gender.const';
import { AgeRangeConst } from './../../planner-edit/constants/AgeRange.const';
import { Operator } from 'src/app/planner/enums/Operator.enum';
import { SegmentTargetType } from 'src/app/planner/constants/SegmentTargetType';
import { PlannerEndpoints } from 'src/app/planner/constants/planner-endpoints.const';
import { IButtonProps, ButtonVariant, IOptionProps } from '@amobee/component-library';
import * as _ from 'lodash';
import { BIESettings } from 'src/app/common/components/browse-include-exclude/browse-include-exclude.component';

@Component({
  selector: 'audience-targeting',
  templateUrl: './audience-targeting.component.html',
  styleUrls: ['./audience-targeting.component.scss']
})
export class AudienceTargetingComponent implements OnInit {

  @Input() group: any;
  @Input() formArray: FormArray;
  @Input() advertiserInfo: AdvertiserInfoVO;
  @Input() isNew: boolean;

  open: boolean = false;
  genderConst = GenderConst;
  ageRangeConst = AgeRangeConst;
  ageRangeKeys = Object.keys(AgeRangeConst);
  ageRangeValues = Object.values(AgeRangeConst);
  rangeSliderConfig: any;
  rangeSelection: any;
  genderKeys = Object.keys(GenderConst);
  ageSelectionLabel: string = '';
  prevDemoSetting: any = {
    gender: GenderConst.All.label,
    ageMax: 11,
    ageMin: 1,
    onTargetGoal: null,
  };

  segmentSetSettings = {
    singleSelection: true,
    textField: "name",
    closeDropDownOnSelection: true,
    enableCheckAll: false,
    allowSearchFilter: true,
    endPoint: PlannerEndpoints.segments,
    params: {}
  };
  SegmentTargetType = SegmentTargetType;
  segmentType: any = '';
  selectedSegmentSet: Array<any> = [];
  audienceDataConfig: any = {
    include: [],
    exclude: [],
    includeOperator: '',
    excludeOperator: ''
  };
  includeSelectionText: any = '';
  excludeSelectionText: any = '';
  segmentSetLabel: string = '';
  tooltipTextForInclude: Array<string> = [];
  tooltipTextForExclude: Array<string> = [];
  audienceSettings: BIESettings = {
    url: PlannerEndpoints.segments
  }
  saveButton: IButtonProps = {
    variant: ButtonVariant.PRIMARY,
    label: 'Save',
    onClick: () => {
      this.saveAudienceTargeting();
    }
  };
  cancelButton: IButtonProps = {
    variant: ButtonVariant.NEUTRAL,
    label: 'Cancel',
    onClick: () => {
      this.cancel();
    }
  };

  constructor() { }

  ngOnInit() {
    this.rangeSliderConfig = {
      step: 1,
      min: this.ageRangeValues[0].id,
      max: this.ageRangeValues[this.ageRangeValues.length - 1].id,
      stepLabel: this.ageRangeKeys
    }
    this.updateGenderVO();
    this.updateAgeSelectionLabel();

    this.segmentType = this.segmentTargetingType.value;
    if (!_.isEmpty(this.segmentSetControl.value)) {
      this.mapSegmentSetData();
    }
    if (this.includeSegmentControl.disabled || this.excludeSegmentControl.disabled) {
      this.saveButton.disabled = true;
    }

    this.segmentSetSettings.params = {
      marketId: this.advertiserInfo.marketId,
      advertiserId: this.advertiserInfo.id,
      segmentType: this.SegmentTargetType.SegmentSet.value,
      limit: 20,
      offset: 0,
      searchString: ''
    };
    this.audienceSettings.param = {
      marketId: this.advertiserInfo.marketId,
      advertiserId: this.advertiserInfo.id,
      segmentType: this.segmentType && this.SegmentTargetType[this.segmentType].value,
      offset: 0,
      limit: 25,
      searchString: '',
      columnKey: ''
    }

    this.updateSelection();
  }

  updateGenderVO() {
    let genderValue = this.genderControl.value;
    if (_.size(genderValue) === 0) {
      this.genderControl.patchValue(this.genderConst.All.label);
    } else {
      this.genderControl.patchValue(this.genderConst[genderValue[0]].label);
    }
  }

  updateAgeSelectionLabel() {
    this.ageSelectionLabel = this.ageRangeValues.find(x => x.id === this.ageMinControl.value).minRange
      + " - " + this.ageRangeValues.find(x => x.id === this.ageMaxControl.value).maxRange;
  }

  onSliderChange(selectedValues: number[]) {
    if (_.size(selectedValues) === 2 && (selectedValues[0] !== this.ageMinControl.value || selectedValues[1] !== this.ageMaxControl.value)) {
      this.ageMinControl.patchValue(selectedValues[0]);
      this.ageMaxControl.patchValue(selectedValues[1]);
    }
  }

  mapSegmentSetData(): void {
    this.selectedSegmentSet = !_.isEmpty(this.segmentSetControl.value) ? [this.segmentSetControl.value] : [];
  }

  changeSegmentType(event: IOptionProps) {
    this.segmentType = event.value || '';
    this.audienceSettings.param.segmentType = this.segmentType && this.SegmentTargetType[this.segmentType].value || '';
    this.audienceDataConfig = {
      include: [],
      exclude: [],
      includeOperator: Operator.or,
      excludeOperator: Operator.or
    };
  }

  saveAudienceTargeting(): void {
    this.open = false;
    this.resetSegmentData();
    this.segmentType === "" ? this.segmentTargetingType.patchValue(null) : this.segmentTargetingType.patchValue(this.segmentType);
    if (this.segmentType === this.SegmentTargetType.SegmentSet.key) {
      if (_.size(this.selectedSegmentSet)) {
        this.segmentSetControl.patchValue({
          id: this.selectedSegmentSet[0].id,
          name: this.selectedSegmentSet[0].name
        });
      }
    } else if (this.segmentType) {
      this.setSegmentSelectedData();
    }
    this.updateSelection();
    this.updateAgeSelectionLabel();
  }

  setSegmentSelectedData(): void {
    let selectedIncSegments = this.mapSelectedSegments(_.clone(this.audienceDataConfig.include));
    this.includeSegmentControl.patchValue(selectedIncSegments);

    let selectedExSegments = this.mapSelectedSegments(_.clone(this.audienceDataConfig.exclude));
    this.excludeSegmentControl.patchValue(selectedExSegments);

    this.includeOperatorControl.patchValue(this.audienceDataConfig.includeOperator);
    this.excludeOperatorControl.patchValue(this.audienceDataConfig.excludeOperator);
  }

  private mapSelectedSegments(selectedSegments: Array<any>): Array<any> {
    return _.map(selectedSegments, (v) => {
      v = _.omit(v, ['segmentType', 'isInclude', 'isExclude']);
      return v;
    });
  }

  updateSelection(): void {
    this.tooltipTextForInclude = [];
    this.tooltipTextForExclude = [];
    this.includeSelectionText = _.size(this.includeSegmentControl.value);
    this.excludeSelectionText = _.size(this.excludeSegmentControl.value);
    if (this.includeSelectionText === 1) {
      this.includeSelectionText = this.includeSegmentControl.value[0].name;
    } else if (this.includeSelectionText > 1) {
      this.includeSelectionText = "(" + this.includeSelectionText + ")";
      this.tooltipTextForInclude = _.map(this.includeSegmentControl.value, (item) => item.name);
    }
    if (this.excludeSelectionText === 1) {
      this.excludeSelectionText = this.excludeSegmentControl.value[0].name;
    } else if (this.excludeSelectionText > 1) {
      this.excludeSelectionText = "(" + this.excludeSelectionText + ")";
      this.tooltipTextForExclude = _.map(this.excludeSegmentControl.value, (item) => item.name);
    }
    this.segmentSetLabel = this.segmentSetControl.value && this.segmentSetControl.value.name || '';
  }

  openSidebar(): void {
    if (!this.isDisabled) {
      this.open = true;
      this.updateAudienceDataConfig();
      this.updatePrevDemoSetting();
    }
  }

  updatePrevDemoSetting() {
    this.prevDemoSetting = {
      gender: _.clone(this.genderControl.value),
      onTargetGoal: _.clone(this.onTargetGoalControl.value),
      ageMin: _.clone(this.ageMinControl.value),
      ageMax: _.clone(this.ageMaxControl.value),
    };
  }

  updateAudienceDataConfig() {
    this.audienceDataConfig = {
      include: _.clone(this.includeSegmentControl.value),
      exclude: _.clone(this.excludeSegmentControl.value),
      includeOperator: _.clone(this.includeOperatorControl.value),
      excludeOperator: _.clone(this.excludeOperatorControl.value)
    };
    this.segmentType = this.segmentTargetingType.value;
    this.mapSegmentSetData();
  }

  cancel(): void {
    this.open = false;
    this.updateAudienceDataConfig();
    this.updateActualDemoSetting();
    this.updateSelection();
  }

  updateActualDemoSetting() {
    if (this.prevDemoSetting) {
      if (this.genderControl.value !== this.prevDemoSetting.gender) {
        this.genderControl.patchValue(_.clone(this.prevDemoSetting.gender));
      }
      if (this.onTargetGoalControl.value !== this.prevDemoSetting.onTargetGoal) {
        this.onTargetGoalControl.patchValue(_.clone(this.prevDemoSetting.onTargetGoal));
      }
      if (this.ageMaxControl.value !== this.prevDemoSetting.ageMax) {
        this.ageMaxControl.patchValue(_.clone(this.prevDemoSetting.ageMax));
      }
      if (this.ageMinControl.value !== this.prevDemoSetting.ageMin) {
        this.ageMinControl.patchValue(_.clone(this.prevDemoSetting.ageMin));
      }
      this.updateAgeSelectionLabel();
    }
  }

  onSegmentSetSelect(event) {
    this.selectedSegmentSet = [{
      id: event.id,
      name: event.name
    }];
  }

  resetSegmentData(): void {
    this.segmentTargetingType.patchValue(null);
    this.includeSegmentControl.patchValue([]);
    this.excludeSegmentControl.patchValue([]);
    this.includeOperatorControl.patchValue(Operator.or);
    this.excludeOperatorControl.patchValue(Operator.or);
    this.segmentSetControl.patchValue({});
  }

  get nielsenDemoControl(): FormGroup {
    return this.formArray.controls[this.group].get("demoSetting") as FormGroup;
  }

  get ageMinControl(): FormControl {
    return this.nielsenDemoControl.get("ageMin") as FormControl;
  }

  get ageMaxControl(): FormControl {
    return this.nielsenDemoControl.get("ageMax") as FormControl;
  }

  get genderControl(): FormControl {
    return this.nielsenDemoControl.get("gender") as FormControl;
  }

  get onTargetGoalControl(): FormControl {
    return this.nielsenDemoControl.get("onTargetGoal") as FormControl;
  }

  get includeSegmentControl(): FormControl {
    return this.formArray.controls[this.group].get("includeSegments") as FormControl;
  }

  get excludeSegmentControl(): FormControl {
    return this.formArray.controls[this.group].get("excludeSegments") as FormControl;
  }

  get includeOperatorControl(): FormControl {
    return this.formArray.controls[this.group].get("includeOperator") as FormControl;
  }

  get excludeOperatorControl(): FormControl {
    return this.formArray.controls[this.group].get("excludeOperator") as FormControl;
  }

  get segmentSetControl(): FormControl {
    return this.formArray.controls[this.group].get("segmentSet") as FormControl;
  }

  get segmentTargetingType(): FormControl {
    return this.formArray.controls[this.group].get("segmentTargetingType") as FormControl;
  }

  get isDisabled(): boolean {
    return this.segmentSetControl.disabled;
  }
}
